<script lang="ts" setup>
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    name: string | undefined
    customSize?: string
    onlineDot?: boolean
    rounded?: boolean
    brandShortName?: boolean
    url?: string
    alt?: string
  }>(),
  { name: "", customSize: "50px", rounded: true },
);

const getAvatarColor = computed(() => {
  const colorIndex = props.name.charCodeAt(0) % 7;
  const colors = [
    "#3498db",
    "#2ecc71",
    "#e74c3c",
    "#f39c12",
    "#9b59b6",
    "#1abc9c",
    "#e67e22",
  ];
  return colors[colorIndex];
});

const getInitials = computed(() => {
  if (!props.name) return "N/A";
  if (props.brandShortName) return props.name;
  const names = props.name?.split(" ");
  if (names?.length > 1) {
    return names[0].charAt(0).toUpperCase() + names[1].charAt(0).toUpperCase();
  }
  else {
    return props.name?.charAt(0)?.toUpperCase();
  }
});
</script>

<template>
  <div
    :style="{
      width: props.customSize,
      height: props.customSize,
      'border-radius': props.rounded ? '50%' : '10px',
      '--avatar-size': props.customSize,
    }"
    class="avatar"
  >
    <span
      v-if="!props.url"
      :style="{
        fontSize: `calc(${props.customSize === '100%' ?
          '100px' : props.customSize} * 0.45)`,
      }"
    >{{ getInitials }}</span>
    <img
      v-else
      :alt="props.alt"
      :src="props.url"
    >
  </div>
</template>

<style scoped>
.avatar {
  @apply text-[20px] flex justify-center items-center relative bg-primary text-white;
}

.avatar span {
  line-height: 1;
}

.online_dot {
  @apply bg-green-500 w-[10px] h-[10px] rounded-full absolute right-[5px] bottom-0;
}
</style>
